import React from 'react';
import { useNavigate } from 'react-router-dom';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import SubscriptionDialog, { DialogButton } from './SubscriptionDialog';
import styles from './PlanUpgradeModal.module.css';

const DEFAULT_BENEFITS = [
  'Acesso a todas as funcionalidades premium',
  'Atualizações exclusivas',
  'Economia de tempo e aumento de produtividade',
];

/**
 * Modal para exibir mensagem de upgrade quando o usuário tenta acessar
 * uma funcionalidade não disponível em sua assinatura. Mesma casca e visual do
 * PlanUpgradeModal.
 *
 * @param {Object} props - Propriedades do componente
 * @param {boolean} props.open - Controla se o modal está aberto
 * @param {Function} props.onClose - Função chamada ao fechar o modal
 * @param {string} props.title - Título do modal
 * @param {string} props.message - Mensagem principal do modal
 * @param {Array} props.benefits - Lista de benefícios a serem exibidos
 * @param {string} props.ctaText - Texto do botão de call-to-action
 * @param {string} props.ctaLink - Link do botão de call-to-action
 * @param {boolean} props.hideCloseButton - Se true, esconde o botão de fechar
 */
const UpgradeModal = ({
  open,
  onClose,
  title = 'Assinatura necessária',
  message = 'Esta funcionalidade requer uma assinatura.',
  benefits = [],
  ctaText = 'Ver planos',
  ctaLink = '/subscription/plans',
  hideCloseButton = false
}) => {
  const navigate = useNavigate();
  const displayBenefits = benefits.length > 0 ? benefits : DEFAULT_BENEFITS;

  const handleCta = () => {
    if (onClose) onClose();
    navigate(ctaLink);
  };

  return (
    <SubscriptionDialog
      open={open}
      onClose={onClose}
      maxWidth={480}
      hideClose={hideCloseButton}
      icon={<span className={styles.iconWrapper}><LockOutlinedIcon fontSize="inherit" /></span>}
      title={title}
      subtitle={message}
      secondaryAction={!hideCloseButton && (
        <DialogButton variant="text" onClick={onClose}>Fechar</DialogButton>
      )}
      actions={<DialogButton onClick={handleCta}>{ctaText}</DialogButton>}
    >
      <div className={styles.benefits}>
        <span className={styles.benefitsTitle}>O que você passa a ter</span>
        <ul className={styles.benefitsList}>
          {displayBenefits.map((benefit) => (
            <li key={benefit} className={styles.benefitItem}>
              <span className={styles.benefitIcon}><CheckRoundedIcon fontSize="inherit" /></span>
              {benefit}
            </li>
          ))}
        </ul>
      </div>
    </SubscriptionDialog>
  );
};

export default UpgradeModal;
